import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { Box, TableCell } from '@material-ui/core'

import { CommissionsButton } from './CommissionsButton'

import { formatPrice } from '../../common/numberUtils'

import { useTableStyles } from '../../hooks/tableStylesHook'

import { MyRowProps } from '../../types/tableTypes'
import { StoreIntegrationType } from '../../types/integrationTypeUtils'
import { IntegrationType } from '../../server/mpsklad_core/Entity/IntegrationType'
import { WbOrderModel } from '../../server/mpsklad_core/Models/Orders/WbOrderModel'
import { OzonOrderModel } from '../../server/mpsklad_core/Models/Orders/OzonOrderModel'
import { StoreOrderModelBase } from '../../server/mpsklad_core/Models/Orders/StoreOrderModelBase'
import { YandexMarketOrderModel } from '../../server/mpsklad_core/Models/Orders/YandexMarketOrderModel'

export type OrderCommissionsCellProps =
  MyRowProps<StoreOrderModelBase>
  & {
  type: StoreIntegrationType
}

export const OrderCommissionsCell =
  observer(
    ({type, row, isSelected}: OrderCommissionsCellProps) => {
      const classes = useTableStyles()

      return (
        <TableCell className={clsx('table-border', classes.noWrapCell, isSelected && 'selected_row')}>
          <Box display="inline-flex" alignItems="center">
            <span>
              {formatPrice(row.commissionFee)}
            </span>

            <CommissionsButton themed type={type} accountId={row.accountId} orderId={row.id}/>
          </Box>
        </TableCell>
      )
    }
  )

export const OzonOrderCommissionsCell =
  (rowProps: MyRowProps<OzonOrderModel>) =>
    <OrderCommissionsCell type={IntegrationType.Ozon} {...rowProps}/>

export const WbOrderCommissionsCell =
  (rowProps: MyRowProps<WbOrderModel>) =>
    <OrderCommissionsCell
      type={IntegrationType.Wildberries} {...rowProps}/>

export const YandexMarketOrderCommissionsCell =
  (rowProps: MyRowProps<YandexMarketOrderModel>) =>
    <OrderCommissionsCell
      type={IntegrationType.YandexMarket} {...rowProps}/>